import React from 'react';
import { useFilterContext } from 'providers/FilterProvider';
import IconButton from 'components/common/IconButton';

const FilterToggle = ({ initialFilter }) => {
  const { filterDispatch } = useFilterContext();

  const handleFilterClick = () => {
    filterDispatch({ type: 'SET_SHOW_FILTER_PANEL', payload: true });
  };

  const handleResetClick = () => {
    filterDispatch({
      type: 'RESET_FILTERS',
      payload: initialFilter,
    });
  };

  return (
    <div className="d-flex gap-2">
      <IconButton
        variant="falcon-default"
        size="sm"
        onClick={handleResetClick}
        icon="redo-alt"
        transform="shrink-3"
      >
        <span className="d-none d-sm-inline-block ms-1">Reset Filter</span>
      </IconButton>

      <IconButton
        variant="falcon-default"
        size="sm"
        onClick={handleFilterClick}
        icon="filter"
        transform="shrink-3"
      >
        <span className="d-none d-sm-inline-block ms-1">Filter</span>
      </IconButton>
    </div>
  );
};

export default FilterToggle;
